// extracted by mini-css-extract-plugin
export default {"panel":"FAQ_panel__63oMz","label":"FAQ_label__LCYzv","title":"FAQ_title__J9Ks9","children":"FAQ_children__WkION"};